import { app } from '../utils/store'
import Swiper from "swiper/bundle"

export default class Gallery {
    constructor({ element }) {
        this.element = element

        this.create(this.element)
    }

    create = (element) => {
        if (element.getAttribute('data-slider') == 'gallery') {
            // Arrows may live outside the slider (e.g. in the section heading)
            const scope = element.closest('[data-slider-scope]') || element

            this.carousel = new Swiper(this.element, {
                speed: 500,
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 10,
                navigation: {
                    nextEl: scope.querySelector('[data-next]') || "[data-next]",
                    prevEl: scope.querySelector('[data-prev]') || "[data-prev]",
                    clickable: true,
                },
                // scrollbar: {
                //     el: ".swiper-scrollbar",
                //     draggable: true,
                // },
                centerInsufficientSlides: true,
                autoHeight: false,
            })
        }
    }
}